import Select from './Select';

export type { Option } from './Select';

export default Select;
